import  { useEffect, useState, useRef } from 'react';
import { Container, Col, Form, Button } from 'react-bootstrap';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import jwt_decode from 'jwt-decode';
import PropTypes from 'prop-types';
// comman components
import Header from '../../layouts/header/index';
import Loader from '../../layouts/loader/index';
// css files
import './space.css';
import { SERVER } from '../../constants/networkUrls';
import { ASSET_FORM_TYPE, SPACE_FORM_TYPE } from '../../constants/stringConstants'
import object from "../../sample.json";
import SpaceDropdown from './SpaceDropdown';
import IncidentDropdown from './IncidentDropdown';
import VandalismDropdown from './VandalismDropdown';
import ImageUpload from './imageUpload';
import { imageFileHandle } from '../../utilities/imageHandleFile';
import ValidationUI from './validationUi'
import PolicyModal from '../../layouts/modal/policyModal';
import { languageCodeMapper } from './translationCodeMapper';
import Labels from '../../components/translations/translation.json'
import FirstModal from '../../layouts/modal/firstModal';
import DeleteFileModal from '../../layouts/modal/deleteFileModal';
import { getComplaintandIncidentLabels, filterIncidentsFromArray } from '../../utilities/assetResponseParser.js';
import {filterComplaintsAndIncidentsByEmployeeOnly} from './filterComplaints.js';
import Footer from '../../layouts/footer/footer';
import settingMobileIcon from '../../Asset/Images/settingMobileIcon.png';
import apiConfig from '../trustBuilder/Auth/services/apiConfig';
import { deleteGUIDCookie, getGUIDCookie } from '../fmstransactions/guidTrack.js';
import { fmsSessionTrack } from '../fmstransactions/fmsTrackCount'
import { isRestrictEmail, isValidEmailInput } from '../email/emailRestriction';
import { clearComplaintStorage, clearIncidentStorage, openAuthenticationTab, clearNMBSLoginSelection, getNMBSLoginSelection, storeAPIImages, getStoredAPIImages, storeComment, getComment, getComplaintLabel, getIncidentLabel, storeImages, getImages, clearSelectionStorage } from '../storage/selectionStorage';
import {  convertFileNamesToPNG } from './imageNameConverter.js';
import { adjustHeight } from './TextAreaAdjuster.js'; // Importing the functions

function Space(props) {
	const [data] = useState({ datas: object });
	const assetData = localStorage.getItem("assetData");
	const localStorageTrustBuilder = JSON.parse(localStorage.getItem("trustBuilder"));
	const assetResponse = JSON.parse(assetData);
	const TVM_CONSTANT = "ticketvendingmachines(tvms)";
	if (assetResponse.isSiteRestricted) {
		localStorage.removeItem("Visitor_FMO");
	}
	let trustBuilder = localStorageTrustBuilder;
	const isVisitor = localStorage.getItem("Visitor_FMO") === "true";
	let isPrivate = assetResponse.isPrivate;
	const [incidentId] = useState(props.assetId);
	const [incidentType, setIncidentType] = useState("");
	const [propertyValue, setPropertyValue] = useState("");
	const [emailInput, setEmailInput] = useState("");
	const [exdId, setExdId] = useState("");
	const [equipmentName, setEquipmentName] = useState("");
	const [incidentArray, setIncidentArray] = useState([]);
	const [vandalismArray, setVandalsimArray] = useState([]);
	const [complaintIncidentMappingState, setComplaintIncidentMappingState] = useState([])
	const [incidentDisabled, setincidentDisabled] = useState(true);
	const [incidentDefaultValue, setincidentDefaultValue] = useState(false);
	const [complaintDefaultValue] = useState(false);
	const [assetType,setAssetType] = useState(assetResponse && assetResponse.assetType);
	const [loadingStatus, setLoadingStatus] = useState(true);
	const [selectedComplaintId, setSelectedComplaintId] = useState("");
	const [selectedCheckComplaint, setSelectedCheckComplaint] = useState("");
	const [imageDeleteModal, setImageDeleteModal] = useState(false);
	const [deletedImageIndex, setdeletedImageIndex] = useState(-1);
	const [selectedIncidentId, setSelectedIncidentId] = useState("");
	const [commentEntered, setCommentEntered] = useState("");
	const [contactNumber, setContactNumber] = useState("");
	const [isPhoneNumberEntered, setIsPhoneNumberEntered] = useState(false);
	const [assetIdEntered, setAssetIdEntered] = useState("");
	const [assetIdNotVisible, setAssetIdNotVisible] = useState(false);
	const [assetIdVisible, setAssetIdVisible] = useState(false);
	const [spaceId, setSpaceId] = useState("");
	const [assetId, setAssetId] = useState("");
	const [buildingNumber] = useState(assetResponse.buildingNumber ? assetResponse.buildingNumber : "");
	const [spaceTypeId, setSpaceTypeId] = useState("");
	const [spaceTypeLabel, setSpaceTypeLabel] = useState("");
	const [incidentTypeLbl, setIncidentTypeLbl] = useState("");
	const [equipmentCodeLbl] = useState(assetResponse?.assetLabel);
	const [propertyId, setPropertyId] = useState("");
	const [images, setImages] = useState([]);
	const [apiImages, setApiImages] = useState([]);
	const [fileTypeModalState, setFileTypeModalState] = useState(false);
	const [isComplaintValidationError, setIsComplaintValidationError] = useState(null);
	const [isAssetValidationError, setIsAssetValidationError] = useState(null);
	const [isvandalismSelectedValidationError, setIsvandalismSelectedValidationError] = useState(null);
	const [isvandalismTypeValidationError, setIsvandalismTypeValidationError] = useState(null);
	const [showVandalism,setShowVandalism] = useState(false);
	const [assetIdEnabled, setAssetIdEnabled] = useState(true);
	const [assetIdCheckDisabled, setAssetIdCheckDisabled] = useState(false);
	const [isConatctValidationError, setIsContactValidationError] = useState(null);
	const [isImageValidationError, setIsImageValidationError] = useState(null);
	const [isIncidentValidationError, setIsIncidentValidationError] = useState(null);
	const [isPrivacyValidationError, setIPrivacyValidationError] = useState(null);
	const [isCommentValidationError, setIsCommentValidationError] = useState(null);
	const [policyModalState, setPolicyModalState] = useState(false);
	const [commentCharCount, setCommentCharCount] = useState(500);
	const [recievedResponse, setRecievedResponse] = useState([]);
	const [charLabel, setCharLabel] = useState(false);
	const [showCookiePopup, setShowCookiePopup] = useState(false);
	const [emailChecked, setEmailChecked] = useState((trustBuilder || (isPrivate && !isVisitor)) ? true : false);
	const [isEmailValidateError, setIsEmailValidateError] = useState(null);
	const [isEmailRestrictedError, setIsEmailRestrictedError] = useState(null);
	const [isValidationError, setIsValidationError] = useState(false);
	const [mobile, setMobile] = useState(window.innerWidth < 1024);
	const [policyChecked, setPolicyChecked] = useState(false);
	const [assetChecked, setAssetChecked] = useState(false);
	const [isSafetySecurity, setIsSafetySecurity] = useState(false);
	const formRef = useRef(null);
	const imageRef = useRef(null);
	const [formHeight, setFormHeight] = useState(0);
	const propertytextareaRef = useRef(null);
	const equipmenttextareaRef = useRef(null);
	const spacetextareaRef = useRef(null);
	const [isVandalism, setIsVandalism] = useState('');
	const [vandalismType, setIsVandalismType] = useState(null);
	let userLangTrustBuilder = languageCodeMapper(localStorage.getItem("languageCode"));
	let userLang = localStorage.getItem("languagePref");
	const [langCode, setlangCode] = useState(userLangTrustBuilder ? userLangTrustBuilder : userLang);
	const MAX_COUNT = 4;
	const [fileLimit, setFileLimit] = useState(false);
	const min_chars = 1;
	const navigate = useNavigate();
	const hostname = window && window.location && window.location.hostname;
	const environmentConstants = apiConfig.setEnvironmentURLs(hostname);
	let imageArr = [];
	let apiImagesArr = [];
	const location = useLocation();
	const [funnelDropParams, setFunnelDropParams] = useState({
		isComplaintSelected: false,
		isIncidentSelected: false,
		isCommentEntered: false,
		isPictureUploaded : false,
		isEmailChecked: false,
		isPrivacyPolicyChecked:false,
		isEmailEntered: false,
		isVandalismIncident:false,
		isVandalismTypeSelected:false,
		isPhoneNumberEntered:false,
		assetIdEntered: false,
		assetIdNotVisible: false
	});
	const [switchedFromVisitorToEmployee, setSwitchedFromVisitorToEmployee] = useState(false);
	const [isWiFiAntennAIncident, setIsWiFiAntennAIncident] = useState(false);

	  useEffect(() => {
	console.log("selectedCheckComplaint in useEffect", selectedCheckComplaint);
		setFunnelDropParams((prevParams) => ({
			...prevParams,
			isComplaintSelected: selectedComplaintId ? true : false,
			isIncidentSelected: selectedIncidentId ? true : false,
			isCommentEntered: commentEntered ? true : false,
			isEmailChecked: emailChecked,
			isPrivacyPolicyChecked: policyChecked,
			isPictureUploaded: images.length > 0 ? true : false,
			isEmailEntered: emailInput ? true : false,
			isVandalismIncident: isVandalism === 'Yes' || isVandalism === 'No',
			isVandalismTypeSelected: isVandalism === 'Yes' && vandalismType !== null,
			switchedFromVisitorToEmployee: switchedFromVisitorToEmployee,
			assetIdEntered: assetIdEntered.length > 0,
			assetIdNotVisible: assetChecked
		}));
  }, [selectedComplaintId,selectedIncidentId,commentEntered,emailInput,emailChecked,policyChecked,images,isVandalism,vandalismType,switchedFromVisitorToEmployee,assetIdEntered,assetChecked,isPhoneNumberEntered]); // This will run whenever emailChecked changes

    useEffect(() => {
    // Handle tab visibility change (inactive/active)
    const handleVisibilityChange = () => {
      if (document.hidden) {
        console.log('Tab is inactive', funnelDropParams);
        fmsSessionTrack(trustBuilder ? "NMBSUser" : "Traveller", true, funnelDropParams);
      } else {
        console.log('Tab is active');
      }
    };

    // Event listener for visibilitychange
    document.addEventListener('visibilitychange', handleVisibilityChange);

    // Handle the beforeunload event (browser close or refresh)
    const handleBeforeUnload = (event) => {
      console.log('Tab is handleBeforeUnload', funnelDropParams);
      fmsSessionTrack(trustBuilder ? "NMBSUser" : "Traveller", true, funnelDropParams);

      // Prevent default browser unload warning
      event.returnValue = '';  // Modern browsers need this to suppress the warning
      // Return '' for older browsers that still rely on it
      return ''; 
    };

    // Add the beforeunload event listener
    window.addEventListener('beforeunload', handleBeforeUnload);

    // Cleanup event listeners on component unmount
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [funnelDropParams, trustBuilder]); // Dependencies for tracking



	const handleVandalismChange = (event) => {
		if(event === ""){
			setIsVandalismType(null);
		}else{
			setIsVandalismType(event);
		}
		setIsvandalismSelectedValidationError(null);
	};
	useEffect(() => {

		// Call adjustHeight initially and when propertyValue changes
		adjustHeight(propertytextareaRef);

		// Handle screen resizing
		const handleResize = () => {
			adjustHeight(propertytextareaRef);
		};

		// Add resize event listener on mount
		window.addEventListener("resize", handleResize);

		// Cleanup event listener on unmount
		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, [isPrivate && propertyValue]); // Dependency on propertyValue to trigger on change

	useEffect(() => {

		// Call adjustHeight initially and when propertyValue changes
		adjustHeight(equipmenttextareaRef);

		// Handle screen resizing
		const handleResize = () => {
			adjustHeight(equipmenttextareaRef);
		};

		// Add resize event listener on mount
		window.addEventListener("resize", handleResize);

		// Cleanup event listener on unmount
		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, [isPrivate && equipmentName]); // Dependency on propertyValue to trigger on change  
	useEffect(() => {

		// Call adjustHeight initially and when propertyValue changes
		adjustHeight(spacetextareaRef);

		// Handle screen resizing
		const handleResize = () => {
			adjustHeight(spacetextareaRef);
		};

		// Add resize event listener on mount
		window.addEventListener("resize", handleResize);

		// Cleanup event listener on unmount
		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, [isPrivate && spaceTypeLabel]); // Dependency on propertyValue to trigger on change


	useEffect(() => {
		console.log("useEffect of Form Height");
		if (formRef.current) {
			const heightofForm = formRef.current.offsetHeight;
			setFormHeight(heightofForm);
		}
	})

	const handleChange = (event) => {
		console.log("handleChange event data is",event.target.value);
		if(event.target.value === "No"){
			setIsVandalismType(null);
			setIsvandalismSelectedValidationError(null);
		}
		setIsVandalism(event.target.value);
		setIsvandalismTypeValidationError(null);
	};

	const handleFileTypeClose = () => {
		setFileTypeModalState(false);
	}
	const handlePolicyClose = () => {
		setPolicyModalState(false);
	}
	const handleValidationPolicyClose = () => {
		setIsValidationError(false);
	}

	const handleNMBSEmployeeLogin = () => {
		const updatedFunnelDropParams = {
			...funnelDropParams,
			switchedFromVisitorToEmployee: true
		};
		fmsSessionTrack(trustBuilder ? "NMBSUser" : "Traveller", true, updatedFunnelDropParams);
		localStorage.removeItem("Visitor_FMO");
		openAuthenticationTab();
	}
	const handlePolicyModal = () => {
		setPolicyModalState(true)
	}

	const handleCookiePopupClose = () => {
		setShowCookiePopup(false);
	}


	const handleFileRead = (files) => {

		console.log("handleFileRead", files)
		files.map(async (file) => {
			const fileType = file.type;

			if (fileType === 'image/jpeg' || fileType === 'image/jpg' || fileType === 'image/png') {

				// Process Logic
				console.log("File and images", file.name);
				let imageResponse = await imageFileHandle(file, images);

				console.log("imageResponse", imageResponse)

				if (imageResponse) {

					imageArr = imageResponse.imageArr;

					apiImagesArr = imageResponse.apiImagesArr;

					if (imageArr?.length === MAX_COUNT) setFileLimit(true);
					const convertedImages = convertFileNamesToPNG(imageArr)
					const convertedapiImagesArr = convertFileNamesToPNG(apiImagesArr)
					let imagesResponseConverted = { 'imageArr': convertedImages, 'apiImagesArr': convertedapiImagesArr }
					console.log("images array and api Images Array", JSON.stringify(imagesResponseConverted));
					setImages(convertedImages)
					setApiImages(convertedapiImagesArr)
					storeImages(imagesResponseConverted)
					setIsImageValidationError(null);
				}
			} else {

				console.log("Entering into not image format");

				setFileTypeModalState(true);

			}

		})

	}
	const handleDeleteImages = (index) => {
		setImageDeleteModal(true);
		setdeletedImageIndex(index);
	}

	const handleEmailChecked = () => {
		setEmailChecked((state) => !state);
		setEmailInput("");
	}

	const handleInputEmail = (e) => {
		setEmailInput(e.target.value);

		if (!isValidEmailInput(e.target.value)) {
			setIsEmailValidateError(Labels[langCode].EMAIL_VALIDATION_ERROR);
			setIsEmailRestrictedError(false);
		} else {
			if (isRestrictEmail(e.target.value)) {
				setIsEmailValidateError(Labels[langCode].DOMAIN_VALIDATION_ERROR);
				setIsEmailRestrictedError(true);
			} else {
				setIsEmailValidateError(null);
				setIsEmailRestrictedError(false);

			}
		}
	}

	const commentValidations = (commentValue) => {
		const max_chars = 500;

		const remainingCount = (max_chars - commentValue.length);

		if (commentEntered.length < min_chars) {
			setIsCommentValidationError(null)
		}

		setCommentCharCount(remainingCount);


		if (commentEntered !== "") {

			setIsCommentValidationError(null);

		}
	}
	const handleComment = (event) => {
		setCharLabel(true);
		let commentValue = event.target.value
		setCommentEntered(commentValue);
		storeComment(event.target.value);
		commentValidations(commentValue);
	}

	const validateContactNumber = (number) => {

		// Rule 2: The number must be between 8 and 9 digits
		if (number && (number.length < 5 || number.length > 14)) {
			setIsContactValidationError(Labels[langCode].CONTACT_VALIDATION_2);
			return false; // Exit validation early if this condition fails
		}

		// Rule 3: Only numeric characters (no spaces, alphabets, or special characters)
		const regex = /^[0-9]*$/;
		if (number && !regex.test(number)) {
			setIsContactValidationError('Contact number can only contain digits and no spaces or special characters.');
			return false; // Exit validation early if this condition fails
		}

		setIsContactValidationError('');

		return true;
		// If all validations pass, clear the error
	};

	const handleConatctNumber = (event) => {
		let contactValue = event.target.value;
		// Remove all non-digit characters
		contactValue = contactValue.replace(/\D/g, '');
		setContactNumber(contactValue);
		validateContactNumber(contactValue);
		setFunnelDropParams((prevParams) => ({
			...prevParams,
			isPhoneNumberEntered: contactValue.length > 0
		}));
	}

	const handleAssetId = (event) => {
		let assetIdValue = event.target.value
		assetIdValue = assetIdValue.replace(/[^a-zA-Z0-9]/g, '');
		setAssetIdEntered(assetIdValue);
		if (assetIdValue.length > 0) {
			setAssetIdCheckDisabled(true);
			setIsAssetValidationError(null);
		} else {
			setAssetIdCheckDisabled(false);
		}
	}

	const handleWindowSizeChange = () => {
		const width = window.innerWidth;
		const height = window.innerHeight;

		// Mobile conditions
		if (width <= 500) {
			setMobile(true);
		}
		// Tablet conditions (portrait or landscape)
		else if (width <= 1024) {
			// Consider tablet in portrait mode as mobile
			if (height > width) {
				setMobile(true);
			}
			// Consider tablet in landscape mode as not mobile
			else {
				setMobile(false);
			}
		}
		// For devices with width greater than 1024px, it's considered as not mobile
		else {
			setMobile(false);
		}
	};


	const populateStoredData = async () => {
		let complaintValue = await getComplaintLabel();
		if (complaintValue) {
			await handleComplaint(complaintValue[0].complaintLabel, complaintValue[0].value.complaintId, complaintValue,true)
			setSelectedComplaintId(complaintValue[0].value.complaintId);
		}
		let incidentValue = await getIncidentLabel();
		if (incidentValue) {
			handleIncidentType(incidentValue[0].incidentTypeLabel,incidentValue[0].incidentId,true)
			setSelectedIncidentId(incidentValue[0].incidentId)
		}
		if (getComment()) {
			setCommentEntered(getComment())
			commentValidations(getComment())
		}
		if (getImages()) {
			let imagesArrayList = []
			let apiImagesArrayList = []
			let imagesStoredResponse = JSON.parse(getImages())
			if (Array.isArray(imagesStoredResponse.imageArr)) {
				imagesArrayList = imagesStoredResponse.imageArr
			} else {
				imagesArrayList = Array.from(imagesStoredResponse.imageArr)
			}

			if (Array.isArray(imagesStoredResponse.apiImagesArr)) {
				apiImagesArrayList = imagesStoredResponse.apiImagesArr
			} else {
				apiImagesArrayList = Array.from(imagesStoredResponse.apiImagesArr)
			}
			setImages(imagesStoredResponse.imageArr)
			setApiImages(imagesStoredResponse.apiImagesArr)
		}
	}


	const clearLocalData = async () => {
		await clearSelectionStorage();
		await clearNMBSLoginSelection();

	}



	useEffect(() => {
		const fetchDataandDisplay = async () => {
			if (trustBuilder && getNMBSLoginSelection()) {
				await populateStoredData();
				await clearSelectionStorage();
				await clearNMBSLoginSelection();
			}
		}
		fetchDataandDisplay();
	}, [])


	useEffect(() => {
		window.addEventListener('resize', handleWindowSizeChange);
		handleWindowSizeChange();
		return () => {
			window.removeEventListener('resize', handleWindowSizeChange);
		};
	}, []);


	useEffect(() => {
		localStorage.setItem("isFormLoaded", true);
		localStorage.setItem("isNMBSEmployeeLoginNeeded", false);
		document.title = isPrivate ? 'FixMyOffice - Request' : 'FixMyStation - Request';
		if (trustBuilder) {
			localStorage.setItem("isNMBSLoginInitiated", false)
			let identityToken = localStorage.getItem("IdentityToken");
			let decoded_token = jwt_decode(identityToken);
			setEmailInput(decoded_token.email ? decoded_token.email : decoded_token.mail);
			setExdId(decoded_token.userId ? decoded_token.userId : decoded_token.sub);
			localStorage.setItem("handleDropDownLangCode", decoded_token.language);
			localStorage.removeItem("IdentityToken");
			localStorage.removeItem("code");
		}

		setShowCookiePopup(true);
	}, [])

	const setSpaceTypeValue = (response, language) => {
		const spaceTypeLabelArray = response.spaceType.spaceTypeLabels
		let labelValueSpace = "";
		spaceTypeLabelArray.filter((spaceLabel) => {
			if (spaceLabel.languageCode === language) {
				labelValueSpace = spaceLabel.label;
			}
		})
		return labelValueSpace;
	}

	const setIncidentTypeValue = (response, language) => {
		const incidentTypeLabelArray = response && response.complaints[0].incidentTypes[0].incidentTypeLabels
		let labelValueIncident = "";
		incidentTypeLabelArray.filter((incidentLabel) => {
			if (incidentLabel.languageCode === language) {
				labelValueIncident = incidentLabel.label;
			}
		})
		const isVandalismVar = response?.complaints?.[0]?.incidentTypes?.[0]?.isVandalismEnabled;
		setShowVandalism(isVandalismVar);
		return labelValueIncident;
	}


	useEffect(() => {
		window.history.pushState(null, document.title, window.location.href);
		window.addEventListener('popstate', function (event) {
			window.history.pushState(null, document.title, window.location.href);
		});
	}, [location]);

	const handleEvent = () => {
		if (!policyModalState) {
			window.location.reload();
		}
	};

	useEffect(() => {
		window.addEventListener("popstate", handleEvent);
		return () => window.removeEventListener("popstate", handleEvent);
	});



	useEffect(() => {
		if (assetResponse && assetResponse.vandalisms !== null) {
			 const sortedVandalismArray = [...assetResponse.vandalisms].sort((a, b) =>
        a.vandalismName.toLowerCase().localeCompare(b.vandalismName.toLowerCase())
    );

			setVandalsimArray(sortedVandalismArray);
		}
		if (assetResponse && assetResponse.complaints !== null) {
			setRecievedResponse(assetResponse);
			setPropertyValue(assetResponse.buildingName);
			setEquipmentName(assetType === TVM_CONSTANT ?  assetResponse.assetLabel : assetResponse.name);
			{ props.formType === SPACE_FORM_TYPE && setSpaceId(assetResponse.spaceId) };
			{ props.formType === SPACE_FORM_TYPE && setSpaceTypeId(assetResponse.spaceType.id) };
			{ props.formType === ASSET_FORM_TYPE && setAssetId(assetResponse.assetId) };
			{ props.formType === SPACE_FORM_TYPE && setPropertyId(assetResponse.buildingId) }


			// 👇 Add filtering based on Visitor_FMO using common function
			let filteredAssetResponse = filterComplaintsAndIncidentsByEmployeeOnly(assetResponse, trustBuilder, isPrivate,props.formType);
			const complaintIncidentMappingArray = getComplaintandIncidentLabels(filteredAssetResponse, langCode);
			setComplaintIncidentMappingState(complaintIncidentMappingArray);

			if (props.formType === SPACE_FORM_TYPE) {
				if (assetResponse.spaceType.spaceTypeLabels) {
					let spaceLabelValueInitial = setSpaceTypeValue(assetResponse, langCode);
					setSpaceTypeLabel(spaceLabelValueInitial)
				}
			}
			if (props.formType === ASSET_FORM_TYPE && assetType !== TVM_CONSTANT) {
				let incidentLabelValueInitial = setIncidentTypeValue(assetResponse, langCode);
				setIncidentTypeLbl(incidentLabelValueInitial);
			}

			fmsSessionTrack(trustBuilder ? "NMBSUser" : "Traveller", true);
			if (trustBuilder) {
				localStorage.setItem("isNMBSLoginInitiated", false);
			}

		} else {
			console.log("Enter into server down page in else");
			navigate("/serverDown");
		}

		setLoadingStatus(false);
	}, []);


	const checkForValidationErrors = (languageCode) => {
		console.log("Language Code", languageCode);

		if (selectedComplaintId === "") {

			setIsComplaintValidationError(Labels[languageCode].COMPLAINT_VALIDATION_ERROR);
		} else {
			setIsComplaintValidationError(null);
		}

		if (assetIdVisible && contactNumber.length === 0) {
			setIsContactValidationError(Labels[languageCode].CONTACT_VALIDATION_2);
		}
		else if (assetIdVisible && contactNumber.length > 0) {
			validateContactNumber(contactNumber)
		}
		else {
			setIsContactValidationError(null);
		}

		if (assetIdEntered === "" && assetIdVisible && !assetChecked) {
			setIsAssetValidationError(Labels[languageCode].ASSETID_VALIDATION);
		} else {
			setIsAssetValidationError(null);
		}

		// Custom validation for ASSET_FORM_TYPE and non-TVM assets
		if (selectedIncidentId === "" && !incidentDisabled) {
			setIsIncidentValidationError(Labels[languageCode].INCIDENT_VALIDATION_ERROR);
		} else {
			setIsIncidentValidationError(null);
		}
		if (commentEntered === "") {
			setIsCommentValidationError(Labels[languageCode].COMMENT_VALIDATION_ERROR);

		} else {
			setIsCommentValidationError(null)
		}

		// Vandalism validations 
		if(showVandalism){
			if(isVandalism === ''){
				setIsvandalismTypeValidationError(Labels[languageCode].SELECT_VANDALSIM_TYPE);
			}else{
				setIsvandalismTypeValidationError(null);
			}
			if(isVandalism === "Yes"){
				if(vandalismType === null){
					setIsvandalismSelectedValidationError(Labels[languageCode].SELECT_VANDALISM_DROPDOWN);
				}else{
					setIsvandalismSelectedValidationError(null);
				}
			}
		}
		
		if (images?.length === 0) {
			setIsImageValidationError(Labels[languageCode].IMAGE_VALIDATION_ERROR);
		} else {
			setIsImageValidationError(null);
		}
		

		if (!policyChecked && !trustBuilder) {
			setIPrivacyValidationError(Labels[languageCode].PRIVACY_POLICY_VALIDATION_ERROR);

		} else {
			setIPrivacyValidationError(null)
		}

		// check for vandalism validations

		if (trustBuilder === true) {
			if (emailChecked && !trustBuilder && (emailInput === "" || !isValidEmailInput(emailInput))) {
				setIsEmailValidateError(Labels[languageCode].EMAIL_VALIDATION_ERROR);
			} else {
				setIsEmailValidateError(null);
			}
		} else {
			if (emailChecked && !trustBuilder && (emailInput === "" || !isValidEmailInput(emailInput) || isRestrictEmail(emailInput))) {
				if (!isValidEmailInput(emailInput)) {
					setIsEmailValidateError(Labels[languageCode].EMAIL_VALIDATION_ERROR);
					setIsEmailRestrictedError(false);
				} else {
					if (isRestrictEmail(emailInput)) {
						setIsEmailValidateError(Labels[languageCode].DOMAIN_VALIDATION_ERROR);
						setIsEmailRestrictedError(true);
					} else {
						setIsEmailValidateError(null);
						setIsEmailRestrictedError(false);
					}
				}
			} else {
				setIsEmailValidateError(null);
			}
		}

		if (trustBuilder) {
			if (
				selectedComplaintId === "" ||
				selectedIncidentId === "" ||
				(showVandalism && isVandalism === '') ||
				(isVandalism === "Yes" && !vandalismType) ||
				commentEntered === "" ||
				(images?.length === 0) ||
				(assetIdVisible && contactNumber?.length === 0 || assetIdVisible && !validateContactNumber(contactNumber)) ||
				(!assetChecked && assetIdVisible && assetIdEntered.length === 0)
			) {
				return false;
			}
		} else {
			if (
				selectedComplaintId === "" ||
				selectedIncidentId === "" ||
				commentEntered === "" ||
				(images?.length === 0) ||
				(
					assetType !== TVM_CONSTANT &&
					(
						!policyChecked ||
						(emailChecked && !trustBuilder && (emailInput === "" || !isValidEmailInput(emailInput))) ||
						isRestrictEmail(emailInput)
					)
				)
			) {
				return false;
			}
		}
		return true;
	}

	const isFurnitureIncident = (postData) => {
		if (postData.complaintId === 'NMBS_008') {
			return true
		}
		return false
	}
	const submitIncidentAPI = async () => {
		if (checkForValidationErrors(langCode)) {
			setLoadingStatus(true);
			clearLocalData()
			const assetTypeValue = props.formType === ASSET_FORM_TYPE ? "Asset" : "Space";
			const apiUrl = `${SERVER.API_BASE_URL}${SERVER.SERVICES.submitIncident}`;
			const bearerToken = localStorage.getItem("TOKEN");
			const assetPostData = {
				"incidentType": assetTypeValue,
				"incidentTypeName": incidentTypeLbl ? incidentTypeLbl : null,
				"assetId": assetId,
				"comment": commentEntered,
				"description": "",
				"complaintId": selectedComplaintId,
				"incidentTypeId": selectedIncidentId,
				"equipmentPlanonId": incidentId,
				"equipmentName": equipmentName,
				"propertyId": "0",
				"propertyCode":buildingNumber,
				"propertyName": propertyValue,
				"requestorEmailId": emailInput,
				"userPhoneNumber": assetIdVisible && isPrivate ? contactNumber : "",
				"isSubscribed": emailChecked,
				"preferredLanguage": langCode,
				"incidentImages": apiImages,
				"isLoggedInUser": trustBuilder,
				"sessionId": getGUIDCookie(),
				"assetNumber": assetIdVisible && isPrivate ? assetIdEntered : "",
				"spaceNumber": isPrivate ? assetResponse.spaceNumber : "",
				"floorName": isPrivate ? assetResponse.floorName : "",
				"city": isPrivate ? assetResponse.city : "",
				"requestorId": (isPrivate || (assetType === TVM_CONSTANT)) ? exdId : "",
				"isPrivate": isPrivate ? true : false,
				"equipmentCode": assetResponse && assetResponse.assetLabel ? assetResponse.assetLabel : "",
...(trustBuilder
    ? isVandalism === "Yes"
      ? { isVandalism: true, vandalismId: vandalismType }
      : { isVandalism: false, vandalismId: null }
    : { isVandalism: null, vandalismId: null })			};

			const spacePostData = {
				"incidentType": assetTypeValue,
				"incidentTypeName": incidentType ? incidentType : null,
				"spaceId": spaceId,
				"spaceTypeName": spaceTypeLabel ? spaceTypeLabel : null,
				"comment": commentEntered,
				"description": "",
				"complaintId": selectedComplaintId,
				"incidentTypeId": selectedIncidentId,
				"equipmentPlanonId": incidentId,
				"equipmentName": equipmentName,
				"propertyId": propertyId,
				"propertyCode":buildingNumber,
				"propertyName": propertyValue,
				"requestorEmailId": emailInput,
				"userPhoneNumber": assetIdVisible && isPrivate ? contactNumber : "",
				"isSubscribed": emailChecked,
				"spaceTypeId": spaceTypeId,
				"preferredLanguage": langCode,
				"incidentImages": apiImages,
				"isLoggedInUser": trustBuilder,
				"sessionId": getGUIDCookie(),
				"assetNumber": assetIdVisible && isPrivate ? assetIdEntered : "",
				"spaceNumber": isPrivate ? assetResponse.spaceNumber : "",
				"floorName": isPrivate ? assetResponse.floorName : "",
				"city": isPrivate ? assetResponse.city : "",
				"requestorId": (isPrivate || (assetType === TVM_CONSTANT)) ? exdId : "",
				"isPrivate": isPrivate ? true : false,
				"equipmentCode": assetResponse && assetResponse.assetLabel ? assetResponse.assetLabel : "",

...(trustBuilder
    ? isVandalism === "Yes"
      ? { isVandalism: true, vandalismId: vandalismType }
      : { isVandalism: false, vandalismId: null }
    : { isVandalism: null, vandalismId: null })
			};


			const postData = props.formType === ASSET_FORM_TYPE ? assetPostData : spacePostData
			let authConfig = {}
			if (isPrivate && !isVisitor) {
				authConfig = {
					headers: {
						"X-API-KEY": environmentConstants.apiKey,
						"Authorization": `Bearer ${bearerToken}`
					}
				}
			} else {
				authConfig = {
					headers: {
						"X-API-KEY": environmentConstants.apiKey,
					}
				}
			}

			axios.post(apiUrl, postData, authConfig).then(response => {
				setLoadingStatus(false);
				const furnitureIncident = isFurnitureIncident(postData);
				if (response.status === 200) {
					// Track the funnel drop when the user successfully submits the incident
					fmsSessionTrack(trustBuilder ? "NMBSUser" : "Traveller", true, funnelDropParams);
					navigate('/submitted', {
						state: {
							incidentNumber: response.data.incidentId,
							languageCode: langCode,
							validUser: emailChecked,
							comment: commentEntered,
							isDuplicateIncident: response.data.statusCode === 200 ? true : false,
							isNMBSEmployee: trustBuilder,
							isPrivate: isPrivate,
							isFurnitureIncident: furnitureIncident,
							isSafetySecurity: isSafetySecurity,
							isTVMIncident: (assetType === TVM_CONSTANT) ? true : false
						}
					});
				} else {
					setLoadingStatus(false);
					navigate("/serverDown");
				}
				deleteGUIDCookie();
			}).catch(error => {
				setLoadingStatus(false);
				navigate("/serverDown");
				deleteGUIDCookie();
			})
		}
		else {
			console.log("Entered into else part of validations");
			setIsValidationError(true);
		}

	}

	const sortArrayIncidentssArray = (array) => {
		array.sort(function (a, b) {
			if (a.incidentTypeLabel < b.incidentTypeLabel) {
				return -1;
			}
			if (a.incidentTypeLabel > b.incidentTypeLabel) {
				return 1;
			}
			return 0;
		});

	}

	const sortArrayComplaintsArray = (array) => {
		array.sort(function (a, b) {
			if (a.complaintLabel < b.complaintLabel) {
				return -1;
			}
			if (a.complaintLabel > b.complaintLabel) {
				return 1;
			}
			return 0;
		});

	}

	

	const complaintArrays = complaintIncidentMappingState.map((complaint) => complaint);

	sortArrayComplaintsArray(complaintArrays)

	const assetIdEnableArray = () => {
		return ["SN_001", "SN_002"]
	}

	const checkIfSecuritySafety = (id) => {
		if (id === "SN_002") {
			setIsSafetySecurity(true)
		} else {
			setIsSafetySecurity(false)
		}
	}

	const handleWiFiAntennaIncidentLogic = (incidentId) => {
		// Check if the selected incident ID is for WiFi Antenna
		console.log("Selected Incident ID for WiFi Antenna Check:", incidentId);
		const isWiFiAntennaId = incidentId === "00.00.12" || incidentId === "00.00.11";
		setIsWiFiAntennAIncident(isWiFiAntennaId);
	}

	const handleComplaint = async (value, id, complaintValue,fromStoredData = false) => {
		const checkComplaint = value;
		if (checkComplaint.length <= 0) {
			setSelectedCheckComplaint("");
			setSelectedComplaintId("");
			setIncidentArray([]);
			setincidentDisabled(true);
			setIsIncidentValidationError(null);
			setIsWiFiAntennAIncident(false);
			clearComplaintStorage();
			if(props.formType === SPACE_FORM_TYPE){
				setIsVandalism("");
				setShowVandalism(false);
				setIsVandalismType(null);
				setIsvandalismSelectedValidationError(null);
				setIsvandalismTypeValidationError(null);
				clearIncidentStorage();
			}
			return
		}
		checkIfSecuritySafety(id);
		if (assetIdEnableArray().includes(id)) {
			setAssetIdVisible(true);

		} else {
			setAssetIdVisible(false);
		}


		if (value) {
			setIsComplaintValidationError(null);
			if(!fromStoredData){
				setSelectedIncidentId("");
				setIsWiFiAntennAIncident(false);
				await clearIncidentStorage();
				if(props.formType === SPACE_FORM_TYPE){
					setIsVandalism("");
					setShowVandalism(false);
					setIsVandalismType(null);
					setIsvandalismSelectedValidationError(null);
				}
			}
		}
		setSelectedCheckComplaint(value);
		setSelectedComplaintId(id);
		let incidentsLabelsArray = complaintValue ? filterIncidentsFromArray(complaintValue, checkComplaint) : filterIncidentsFromArray(complaintIncidentMappingState, checkComplaint);

		// Remove duplicate incidents by incidentId (or incidentTypeId if that's the unique key)
		const uniqueIncidentsMap = new Map();
		incidentsLabelsArray.forEach(incident => {
			// Use incidentId or incidentTypeId as the unique key
			const key = incident.incidentId || incident.incidentTypeId;
			if (!uniqueIncidentsMap.has(key)) {
				uniqueIncidentsMap.set(key, incident);
			}
		});
		const uniqueIncidents = Array.from(uniqueIncidentsMap.values());

		if (props.formType === ASSET_FORM_TYPE && assetType !== TVM_CONSTANT && uniqueIncidents.length > 0) {
			const firstIncidentId = uniqueIncidents[0].incidentId;
			handleWiFiAntennaIncidentLogic(firstIncidentId);
			setSelectedIncidentId(firstIncidentId)
		}

		sortArrayIncidentssArray(uniqueIncidents);
		setIncidentArray(uniqueIncidents);
		setincidentDisabled(false);
	}

	const translatedComplaintValue = (selectedCheckComplaint) => {
		const incidentsTranslatedLabelsArray = filterIncidentsFromArray(complaintArrays, selectedCheckComplaint);
		setIncidentArray(incidentsTranslatedLabelsArray);
	}




	const handledropdown = (e) => {
		setlangCode(e.target.value);
		localStorage.setItem("languagePref", e.target.value);
		userLang = localStorage.getItem("languagePref");
		setlangCode(userLang);


		// Filter complaints and incidents based on isForEmployeeOnly at incident level using common function
		let filteredResponse = filterComplaintsAndIncidentsByEmployeeOnly(recievedResponse, trustBuilder, isPrivate,props.formType);
		const complaintIncidentMapping = getComplaintandIncidentLabels(filteredResponse, e.target.value);
		setComplaintIncidentMappingState(complaintIncidentMapping);

		if (props.formType === SPACE_FORM_TYPE) {
			if (recievedResponse.spaceType.spaceTypeLabels) {
				let spaceLabelValueInitial = setSpaceTypeValue(recievedResponse, e.target.value);
				setSpaceTypeLabel(spaceLabelValueInitial);
			}
		}

		if (props.formType === ASSET_FORM_TYPE && assetType !== TVM_CONSTANT) {
			const incidentLabelValueInitial = setIncidentTypeValue(recievedResponse, e.target.value);
			setIncidentTypeLbl(incidentLabelValueInitial);
		}

		if (recievedResponse && recievedResponse.vandalisms) {
			const sortedByLanguage = [...recievedResponse.vandalisms].sort((a, b) => {
				const aLabel = a.vandalismLabels.find(label => label.languageCode === e.target.value)?.name || '';
				const bLabel = b.vandalismLabels.find(label => label.languageCode === e.target.value)?.name || '';
				return aLabel.toLowerCase().localeCompare(bLabel.toLowerCase());
			});
			setVandalsimArray(sortedByLanguage);
		}

		if (isComplaintValidationError || isIncidentValidationError || isCommentValidationError || isImageValidationError || isPrivacyValidationError || isEmailValidateError) {
			checkForValidationErrors(e.target.value);
		}
	}
	const handleIncidentType = (value, id,fromStoredData = false) => {
		if (value.length <= 0) {
			setIncidentType("");
			setIncidentTypeLbl("");
			setSelectedIncidentId("");
			clearIncidentStorage();
			setIsWiFiAntennAIncident(false);
			return
		}
		if (value) {
			setIsIncidentValidationError(null)
		}
		// Handle WiFi antenna instruction visibility
		handleWiFiAntennaIncidentLogic(id);
		setShowVandalism(fromStoredData);
		setIncidentType(value);
		setIncidentTypeLbl(value);
		setSelectedIncidentId(id);
		setincidentDefaultValue(false);
	}

	const handlePolicyCheked = () => {
		setPolicyChecked((state) => !state);
		if (!policyChecked) {

			setIPrivacyValidationError(null);

		}

	}

	const handleAssetIdCheked = () => {
		setAssetIdEnabled((state) => !state);
		setAssetChecked((state) => !state);
		if (assetIdEnabled) {
			setIsAssetValidationError(null);
		}

	}

	const callbackImageDeleteClose = () => {
		setImageDeleteModal(false);
	}

	const callbackImageDelete = () => {

  // Parse images if needed
  let imagesArrayList = Array.isArray(images) ? images : JSON.parse(images);
  let apiImagesArrayList = Array.isArray(apiImages) ? apiImages : JSON.parse(apiImages);

  // Filter out the image at deletedImageIndex for both arrays
  const deletedImagesArray = imagesArrayList.filter((_, i) => i !== deletedImageIndex);
  const deletedAPIImagesArray = apiImagesArrayList.filter((_, i) => i !== deletedImageIndex);

  // Update states
  setImages(deletedImagesArray);
  setApiImages(deletedAPIImagesArray);

  // Reset file limit if applicable
  if (deletedImagesArray.length < MAX_COUNT) {
    setFileLimit(false);
  }

  // Close modal
  setImageDeleteModal(false);

};


	const handleOnClickOnForm = () => {
		setCharLabel(false);
	}

	const hideImageIfWidthisLessthan1024 = () => {
		return window.innerWidth < 1024 ? true : false
	}


	return (
		<>
			<Header
				langCode={langCode}
				handledropdown={handledropdown}
				disableFMSTitle={true}
				isPrivate={(!mobile && !hideImageIfWidthisLessthan1024()) && isPrivate}
				isFormPage={true}
			/>
			{showCookiePopup && <FirstModal callbackClose={handleCookiePopupClose} isInitialPopup={false} langCode={langCode} />}
			{loadingStatus === false ?
				<div
					tabIndex="0"
					onKeyDown={(e) => {
						if (e.key === 'Enter' || e.key === ' ') {
							// Trigger same click logic on keyboard
						}
					}}
					style={(mobile || hideImageIfWidthisLessthan1024()) && isPrivate ? {
						position: 'absolute',
						top: '50px',  // Set the top to 0 to start from the top of the page
						left: 0,
						right: 0,
						zIndex: -1,  // Keep the background behind other elements
						width: '100vw',  // Ensure it takes full width of the viewport
						minHeight: '100%',  // Ensure the background covers the entire height of the page, even with scrollable content
						backgroundColor: '#006AB3',  // Blue background color for the entire screen
						backgroundImage: 'url(/images/fixMyOfficeBackground.png)',  // Background image
						backgroundRepeat: 'no-repeat',  // No repeating of the background image
						backgroundSize: '100% 250px',  // Image should fill the width and be 250px high
						backgroundPosition: 'top center',  // Ensure image is centered horizontally and at the top
					} : {}} className={isPrivate ? "container-mainrowFMO" : "container-mainrow"} onClick={handleOnClickOnForm}>

					<div fluid className={mobile ? "container-subMain-mobile" : "container-subMain"}>
						{!isPrivate && <Col xl={5} lg={5} md={4} sm={0} xs={0} xxs={0}>
							{mobile && <div fluid className="container-setting-logo">
								<div>
									<img className="settingIcon-img" width={50} height={50} src={settingMobileIcon} alt="Setting Logo" />
								</div>
							</div>
							}
							<Container fluid className="fmsTitle-label">
								<div>
									<label className="text-label">
										{isPrivate ? Labels[langCode].FIXMYOFFICE : Labels[langCode].FIXMYSTATION}
									</label>
								</div>
							</Container>
						</Col>}

						<div className={isPrivate ? 'div-containerFMO' : (mobile ? 'div-containerMobile' : 'div-container')}>

							<div className={isPrivate && !mobile && !hideImageIfWidthisLessthan1024() ? "main-columnFMO" : (isPrivate && mobile ? "main-column-FMO" : "main-column")}>
								<div ref={formRef} className="form-container">
									{isPrivate && <div fluid className="fmoTitle-label">
										<div>
											<label className="text-label">
												{Labels[langCode].FIXMYOFFICE}
											</label>
										</div>
									</div>}
									{(isPrivate && isVisitor) && <label className="text-label" style={{ fontStyle: 'italic' }}>

										{Labels[langCode].FMO_EMPLOYEE_TEXT}
									</label>}

									<SpaceDropdown
										label={Labels[langCode].COMPLAINT}
										callbackfunc={handleComplaint}
										langCode={langCode}
										translatedComplaintCallback={translatedComplaintValue}
										complaintDefaultValue={complaintDefaultValue}
										array={complaintArrays}
									/>
									{isComplaintValidationError && <ValidationUI label={isComplaintValidationError} />}
									{(props.formType === SPACE_FORM_TYPE || assetType == TVM_CONSTANT) &&
										<div data-testid="incident-dropdown">
											<IncidentDropdown
												label={Labels[langCode].INCIDENT_TYPE}
												callbackfunc={handleIncidentType}
												array={incidentArray}
												langCode={langCode}
												incidentType={incidentType}
												incidentDefaultValue={incidentDefaultValue}
												incidentDisabled={incidentDisabled}
											/>
											{isIncidentValidationError ? <ValidationUI label={isIncidentValidationError} /> : ""}

										</div>
									}

									{(props.formType === ASSET_FORM_TYPE && assetType !== TVM_CONSTANT) && <Form.Group as={Col} className="form-group" >
										<Form.Label className="form-label"> {Labels[langCode].INCIDENT_TYPE} :</Form.Label>
										<Form.Control type="text" className="input" value={incidentTypeLbl} aria-describedby="passwordHelpBlock" disabled autoComplete="on" maxLength="200" />
									</Form.Group>}
									{props.formType === ASSET_FORM_TYPE && isPrivate && <Form.Group as={Col} className="form-group" >
										<Form.Label className="form-label"> {Labels[langCode].EQUIPMENT_CODE} :</Form.Label>
										<Form.Control type="text" className="input" value={equipmentCodeLbl} aria-describedby="passwordHelpBlock" disabled autoComplete="on" maxLength="200" />
									</Form.Group>}
									{/*Asset ID Field*/}
									{assetIdVisible && <div>
										<Form.Group as={Col} className="form-group" >
											<Form.Label className="form-label">{Labels[langCode].ASSET_ID} <span style={{ color: 'red' }}>*</span> :</Form.Label>
											<Form.Control type="text" className="input" aria-describedby="passwordHelpBlock" disabled={!assetIdEnabled} autoComplete="on" maxLength="15" onChange={handleAssetId} value={assetIdEntered} />
										</Form.Group>
										{isAssetValidationError ? <ValidationUI label={isAssetValidationError} /> : ""}

										<Form.Group as={Col} className="form-group-assetIdselection">
											<Form.Check type="checkbox" style={{
												opacity: assetIdCheckDisabled ? 0.1 : 1,  // Change opacity when disabled
												backgroundColor: assetIdCheckDisabled ? '#d3d3d3' : '',  // Light gray background
												borderColor: assetIdCheckDisabled ? '#b0b0b0' : '',  // Lighter border
											}} data-testid="privacy-checkbox" className="keep-check" disabled={assetIdCheckDisabled} checked={assetChecked} onChange={handleAssetIdCheked} />
											<span className='check_text_policy'> {Labels[langCode].ASSET_ID_SELECTION}</span>
										</Form.Group>
									</div>}
									{props.formType === ASSET_FORM_TYPE && <Form.Group as={Col} className="form-group" >
										<Form.Label className="form-label">{Labels[langCode].EQUIPMENT} :</Form.Label>
										<Form.Control type="text" className="input" defaultValue={equipmentName} aria-describedby="passwordHelpBlock" disabled autoComplete="on" maxLength="200" as={"textarea"} ref={equipmenttextareaRef} style={{
											resize: "none", // Disable manual resizing
											paddingTop: "10px",  // Adjust top padding for vertical centering
											paddingBottom: "5px", // Reduce bottom padding to be smaller than the top padding
											lineHeight: "normal",  // Ensure proper line height
											minHeight: "45px",  // Ensure a minimum height for a single line
											textAlign: "left",  // Left-align the text inside the textarea
										}} />
									</Form.Group>}
									<Form.Group as={Col} className="form-group" >
										<Form.Label className="form-label">{Labels[langCode].PROPERTY} :</Form.Label>
										<Form.Control type="text" className="input" defaultValue={propertyValue} aria-describedby="passwordHelpBlock" as={"textarea"} ref={propertytextareaRef} disabled autoComplete="on" maxLength="200" style={{
											resize: "none", // Disable manual resizing
											paddingTop: "10px",  // Adjust top padding for vertical centering
											paddingBottom: "5px", // Reduce bottom padding to be smaller than the top padding
											lineHeight: "normal",  // Ensure proper line height
											minHeight: "45px",  // Ensure a minimum height for a single line
											textAlign: "left",  // Left-align the text inside the textarea
										}}

										/>
									</Form.Group>
									{assetResponse["spaceType"] !== null && <Form.Group as={Col} className="form-group">
										<Form.Label className="form-label">{Labels[langCode].SPACE} :</Form.Label>
										<Form.Control type="text" className="input" value={spaceTypeLabel} aria-describedby="passwordHelpBlock" disabled autoComplete="on" maxLength="200" as="textarea" ref={spacetextareaRef} style={{
											height: '45px',
											marginTop: 'auto',
											marginBottom: 'auto',
											display: 'block',
										}} />
									</Form.Group>}
									<Form.Group as={Col} className="form-group" >
										<Form.Label className="form-label">{Labels[langCode].COMMENT} <span style={{ color: 'red' }}>*</span> :</Form.Label>
										<Form.Control data-testid="commentbox-label" as={isPrivate ? "textarea" : "input"} maxLength={500} row={3} className="input" aria-describedby="passwordHelpBlock" onChange={handleComment} value={commentEntered} />
										{
											charLabel ? <div><label className="comment-validate-text">{Labels[langCode].COMMENT_CHARACTERS_PART1}</label> <label className="comment-validate-text"> {commentCharCount}</label> <label className="comment-validate-text"> {Labels[langCode].COMMENT_CHARACTERS_PART2}</label>
											</div> : ""
										}

										{isCommentValidationError ? <ValidationUI label={isCommentValidationError} /> : ""}
									</Form.Group>

									{trustBuilder && showVandalism && (
	<div>
		<label>{Labels[langCode].IS_INCIDENT_DUE_TO_VANDALISM} <span style={{ color: 'red' }}>*</span> :</label>

		{/* Radio button group */}
		<div style={{ display: 'flex', gap: '30px', marginTop: '8px' }}>
			<label style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
				<input
					type="radio"
					name="vandalism"
	value="Yes"
	checked={isVandalism === "Yes"}
					onChange={handleChange}
				/>
				{Labels[langCode].VANDALISM_YES}
			</label>

			<label style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
				<input
					type="radio"
					name="vandalism"
	value="No"
	checked={isVandalism === "No"}
					onChange={handleChange}
				/>
				{Labels[langCode].VANDALISM_NO}

			</label>
		</div>

		{/* Validation message - shown below */}
		{isvandalismTypeValidationError && (
			<div style={{ marginBottom: '5px' }}>
				<ValidationUI label={isvandalismTypeValidationError} />
			</div>
		)}
	</div>
)}

									{(isVandalism === "Yes" && showVandalism) && (
										<div style={{ marginBottom: '16px' }}>
											<VandalismDropdown
												label={Labels[langCode]?.VANDALISM_TYPE || "Vandalism Type"}
												callbackfunc={handleVandalismChange}
												langCode={langCode}
												vandalisms={vandalismArray}        // pass the vandalisms array here
											/>
											{isvandalismSelectedValidationError ? <ValidationUI label={isvandalismSelectedValidationError} /> : ""}
										</div>
									)}
									<div data-testid="image-upload">
										<ImageUpload
											label={Labels[langCode].ADD_PICTURE}
											callbackfunc={handleFileRead}
											array={images.length > 0 && images}
											fileType={fileTypeModalState}
											fileLimit={fileLimit}
											callbackFileType={handleFileTypeClose}
											warningLabel={data.datas.object.warningLabel}
											callbackdeleteImages={handleDeleteImages}
											langCode={langCode}
											isWiFiAntennAIncident={isWiFiAntennAIncident}
										/>
										{isImageValidationError ? <ValidationUI label={isImageValidationError} /> : ""}
										{imageDeleteModal ? <DeleteFileModal langProp={langCode} callbackImageDeleteClose={callbackImageDeleteClose} callbackImageDelete={callbackImageDelete} /> : ""}
									</div>
									{/*Phone Number Field*/}
									{assetIdVisible && <div>
										<Form.Group as={Col} className="form-group" >
											<Form.Label className="form-label">{Labels[langCode].CONTACT_NUMBER} <span style={{ color: 'red' }}>*</span> :</Form.Label>
											<Form.Control type="text" className="input" aria-describedby="passwordHelpBlock" maxLength={14} autoComplete="on" onChange={handleConatctNumber} value={contactNumber} />
										</Form.Group>

										{isConatctValidationError ? <ValidationUI label={isConatctValidationError} /> : ""}
									</div>}
									{/* Hide INCIDENT_STATUS_CHECKBOX, EMAIL, and PRIVACY fields for TVM_CONSTANT */}
									{assetType !== TVM_CONSTANT && (
										<>
											{!trustBuilder && (
												<Form.Group as={Col} className="form-group-checkEmail">
													<Form.Check type="checkbox" className="keep-check" defaultChecked={(trustBuilder || (isPrivate && !isVisitor)) ? true : false} disabled={(trustBuilder || (isPrivate && !isVisitor)) ? true : false} onChange={handleEmailChecked} />
													<span className='check_text'> {Labels[langCode].INCIDENT_STATUS_CHECKBOX}</span>
												</Form.Group>
											)}
											{emailChecked && !trustBuilder && (
												<>
													<Form.Group as={Col} className="form-group-emailInput">
														{emailChecked ? <Form.Label className="form-label">{Labels[langCode].EMAIL} <span style={{ color: 'red' }}>*</span> :</Form.Label> : <Form.Label className="form-label">{Labels[langCode].EMAIL} :</Form.Label>}
														<Form.Control type="text" className="input" defaultValue={emailInput} aria-describedby="passwordHelpBlock" disabled={trustBuilder ? true : false} autoComplete="on" maxLength="200" onChange={handleInputEmail} />
													</Form.Group>
													{isEmailValidateError ? <ValidationUI label={isEmailValidateError} click={isEmailRestrictedError && Labels[langCode].NMBS_EMPLOYEE_LOGIN1 + " " + Labels[langCode].NMBS_EMPLOYEE_LOGIN2} callbackfunc={handleNMBSEmployeeLogin} /> : ""}
												</>
											)}
											{!trustBuilder && (
												<Form.Group as={Col} className="form-group-checkpolicy">
													<Form.Check type="checkbox" data-testid="privacy-checkbox" className="keep-check" defaultChecked={policyChecked} onChange={handlePolicyCheked} />
													<span className='check_text_policy'> {Labels[langCode].PRIVACY_PART1}</span>
													<span role="button" className='text-policy' onClick={handlePolicyModal} onKeyDown={(e) => {if (e.key === 'Enter' || e.key === ' ') {}}} onMouseOver={ () => {} } onFocus={ () => {} }> {Labels[langCode].PRIVACY_POLICY}</span>
													<span className='check_text_policy_second'> {Labels[langCode].PRIVACY_PART2} <span style={{ color: 'red' }}>*</span></span>
													{isPrivacyValidationError ? <ValidationUI label={isPrivacyValidationError} /> : ""}
													{policyModalState ? <PolicyModal langCode={langCode} callbackClose={handlePolicyClose} /> : ""}
												</Form.Group>
											)}
										</>
									)}
									{
										isValidationError && <PolicyModal langCode={langCode} errorText={Labels[langCode].VALIDATION_POPUP_ERROR} callbackClose={handleValidationPolicyClose} />
									}

									<Button role="button" className="form_btn" style={{ fontSize: '17px', marginTop: '10px' }} onClick={submitIncidentAPI}>{Labels[langCode].SUBMIT}</Button>
								</div>

							</div>


							{isPrivate && (!mobile && !hideImageIfWidthisLessthan1024()) && <div>
								<div fluid ref={imageRef} style={{ height: formHeight + 50 }} className={assetIdVisible ? "image-office-asset" : "image-container"} >

									<img
										style={{ height: formHeight + 50 }}
										className="image-office"
										src={'/images/fixMyOfficeBackground.png'}
										alt="Canvas Logo"
										width='100%'
										height='100%'
										object-fit='cover'
									/>
								</div>
							</div>}
						</div>
					</div>
					<Col xl={1} lg={1} md={0} sm={0} xs={0} xxs={0}>
						<div>
						</div>
					</Col>
					<Footer langCode={langCode} />
				</div>
				: <Loader />}
		</>
	);
}

Space.propTypes = {
	formType: PropTypes.string.isRequired,
	assetId: PropTypes.string,
};

export default Space;

